// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_81-0";